export default Object.freeze({
  Pending: 1,
  Installing: 2,
  Running: 3,
  Completed: 4,
  Failed: 5,
  Expired: 6,
  Error: 7,
  NotFound: 8,
});
